module.exports = __webpack_public_path__ + "entry-150bfe9b/jonas-masanneck.256x256-48bf1631d45be0c954059935410c4958.webp";